import { createAsyncThunk } from "@reduxjs/toolkit";

import { PROJECT_ID_FIELD } from "Constants/constants";
import logger from "Libs/logger";
import { AsyncThunkOptionType } from "Reducers/types";

import { AddCertificateReturnPayload, AddCertificateProps } from "../";
import { addCertificateRequest } from "Api/certificate/addCertificate.request";

// To "mock" creating a certificate, use https://regery.com/en/security/ssl-tools/self-signed-certificate-generator to create a self-signed certificate

/**
 * Add one Certificate
 *
 * @param {string} organizationDescriptionId
 * @param {object} project
 * @param {object} certificate
 *
 */

export const addCertificate = createAsyncThunk<
  AddCertificateReturnPayload | undefined,
  AddCertificateProps,
  AsyncThunkOptionType
>(
  "app/projectCertificate/add_certificate",
  async (
    { organizationDescriptionId, project, certificate },
    { rejectWithValue }
  ) => {
    try {
      const result = await addCertificateRequest({
        project,
        certificate: certificate.certificate,
        key: certificate.key,
        chain: certificate.chain
      });

      if (result?.code && result.code >= 400) {
        return rejectWithValue({
          error:
            result.detail || result.message || "Failed to create certificate"
        });
      }

      const newCertificate = result?._embedded?.entity;

      if (!newCertificate) {
        return rejectWithValue({
          error: "Certificate created but entity not returned"
        });
      }

      return {
        certificate: newCertificate!,
        projectDescriptionId: project[PROJECT_ID_FIELD]
      };
    } catch (err: unknown) {
      logger(err, {
        action: "addCertificate",
        organizationDescriptionId,
        project,
        certificate
      });

      return rejectWithValue(err);
    }
  },
  {
    condition: ({ project }: AddCertificateProps): boolean =>
      !!project._links?.["#certificates"].href
  }
);
